import DimensionInput from "./DimensionInput/DimensionInput"
import QuantityInput from "./QuantityInput/QuantityInput"


export const SpecialInputs = {
    dimension: DimensionInput,
    quantity: QuantityInput
}
